import axios from "axios";

let companyName = sessionStorage.getItem("companyName");
export const visitorData = async () => {
  return await axios.get(`${process.env.REACT_APP_HOST}/newvisitors`);
};
export const categoryData = async () => {
  return await axios.get(`${process.env.REACT_APP_HOST}/categories`);
};
export const branchData = async () => {
  return await axios.get(`${process.env.REACT_APP_HOST}/branches`);
};

